import React from "react";
import { useLang } from "../../context/LanguageContext";
import { TID } from "../../constants/testIds";

const WhatsAppButton = ({ message }) => {
    const { lang } = useLang();
    const number = "919987070049";
    const defaultMsg =
        lang === "mr"
            ? "नमस्कार! मला सुखकर्ता पतपेढीच्या योजनांविषयी अधिक माहिती हवी आहे."
            : "Hello! I would like to know more about Sukhakarta Patsanstha schemes.";
    const text = encodeURIComponent(message || defaultMsg);
    const href = `https://wa.me/${number}?text=${text}`;

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={TID.whatsappFab}
            aria-label="Chat on WhatsApp"
            className="fixed bottom-6 right-6 z-50 group"
        >
            <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-40" />
            <span className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center shadow-2xl ring-4 ring-white transition-all hover:scale-105">
                <i className="fa-brands fa-whatsapp text-2xl sm:text-3xl" />
            </span>
            <span className="hidden md:block absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-slate-900 text-white text-xs font-semibold px-3 py-1.5 rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
                {lang === "mr" ? "व्हॉट्सअ‍ॅप वर संपर्क" : "Chat with us"}
            </span>
        </a>
    );
};

export default WhatsAppButton;
